export default {
    IndicacaoFiliado: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "indicacao-filiado"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/IndicacaoFiliado.js
// module id = GKVz
// module chunks = 16